import { useMemo } from "react";
import { useSelector } from "react-redux";
import GoogleMapReact from "google-map-react";
import { CircularProgress } from "@material-ui/core";

import WhiteLocation from "../../assets/images/icons/map/whiteLocation.png";
import { MAP_ICON_COLORS, MAP_LEGENDS } from "../../pages/dashboard/constants";
import { Icon } from "../base/Icon";
import { LocationIcon } from "./LocationIcon";
import { MapLegends } from "./MapLegends";

export const DEFAULT_CENTER = { lat: 53.399229999999996, lng: -2.6992925 };

export const Map = ({ legends, setClickedBuilding, height, mapTab, properties }) => {
  const { user } = useSelector((state) => state.auth);

  const center = useMemo(() => {
    if (!properties?.length) return undefined;
    let sumLat = 0;
    let sumLng = 0;
    for (const property of properties) {
      sumLat += property.lat;
      sumLng += property.long;
    }
    return {
      lat: sumLat / properties.length,
      lng: sumLng / properties.length,
    };
  }, [properties, mapTab]);

  const buildingData = useMemo(() => {
    if (user.is_testing && mapTab !== undefined) {
      if (properties) {
        const statusedBuilding = properties.map((obj) => {
          return {
            ...obj,
            status:
              MAP_LEGENDS[mapTab][Math.floor(Math.random() * MAP_LEGENDS[mapTab].length)].status,
          };
        });

        return statusedBuilding;
      }
    }

    return properties;
  }, [properties, mapTab]);

  return (
    <div style={{ height: height, width: "100%" }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_API_KEY }}
        defaultCenter={DEFAULT_CENTER}
        center={center}
        defaultZoom={3}
      >
        {buildingData?.map((property) => {
          const color = MAP_ICON_COLORS[property?.status];
          if (color) {
            return (
              <LocationIcon
                key={property.id}
                lat={property.lat}
                lng={property.long}
                color={MAP_ICON_COLORS[property?.status]}
                onClick={() => setClickedBuilding(property)}
                style={{ position: "relative", top: -42, left: -16 }}
              />
            );
          }
          return (
            <Icon
              key={property.id}
              lat={property.lat}
              lng={property.long}
              src={WhiteLocation}
              hoverable
              style={{ position: "relative", top: -14, left: -11 }}
            />
          );
        })}

        {properties?.length === 0 && (
          <CircularProgress color="primary" lat={DEFAULT_CENTER.lat} lng={DEFAULT_CENTER.lng} />
        )}
      </GoogleMapReact>
      <MapLegends legends={legends} />
      <div style={{ height: 20 }}></div>
    </div>
  );
};

Map.defaultProps = {
  height: 400,
  legends: [],
};
